export const connectedDomNodesReducer = (domNodes: HTMLElement[], newNode: HTMLElement): HTMLElement[] => {
  const connectedNodes = domNodes.filter((node) => node.isConnected && node !== newNode);
  return [...connectedNodes, newNode];
};
